module.exports = __webpack_public_path__ + "img/qu_nl.60c1024.jpg";